import React from "react";
import ReactDOMServer from "react-dom/server";
import { IconSearch } from "@tabler/icons-react";

/** Naranja alineado con `.orange` / tema escenario 2 */
export const HINT_PISTA_ORANGE = "#FF6017";

/**
 * Icono lupa + «Pista» (sin recuadro). Mismo aspecto en quiz y en modales SweetAlert.
 * @param {string} [accent] color icono y texto
 */
export function hintMarkPistaHtml(accent = HINT_PISTA_ORANGE) {
	return ReactDOMServer.renderToStaticMarkup(
		<span className="hint-mark hint-mark--pista" style={{ color: accent }}>
			<IconSearch size={34} stroke={1.75} color="currentColor" aria-hidden />
			<span className="hint-mark__label">Pista</span>
		</span>
	);
}

export default function HintMarkPista({ color = HINT_PISTA_ORANGE, className = "" }) {
	return (
		<span className={`hint-mark hint-mark--pista ${className}`.trim()} style={{ color }}>
			<IconSearch size={34} stroke={1.75} color="currentColor" aria-hidden />
			<span className="hint-mark__label">Pista</span>
		</span>
	);
}
